import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, Mutation, State } from 'vuex-class';
import store from '@/store/store';

import TempoController from '@/../bower_components/teknisavuecomponents/components/time/Tempo';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import LocalizacaoController from '@/assets/ts/controller/LocalizacaoController';
import ConfirmationDialog from '@/../bower_components/teknisavuecomponents/components/popups/ConfirmationDialog.vue';

import RegistroPontoUnidadeNumericKeyboard from '@/components/registroPontoUnidade/RegistroPontoUnidadeNumericKeyboard.vue';
import CameraController from '@/assets/ts/controller/CameraController';
import PopupController from '@/assets/ts/controller/PopupController';
import OperadorController from '@/assets/ts/controller/OperadorController';
import ReconhecimentoFacialController from '@/assets/ts/controller/ReconhecimentoFacialController';
import OfflineController from '@/assets/ts/controller/OfflineController';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import Constants from '@/assets/ts/configuration/Constants';
import IntervalController from '@/assets/ts/controller/IntervalController';
import MessageType from '@/assets/ts/interfaces/MessageType';
import Time from '@/../bower_components/teknisavuecomponents/assets/utils/Time';
import LoadingController from '@/assets/ts/controller/LoadingController';
import { Html5Qrcode } from "html5-qrcode";
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import VinculoRepository from '@/assets/ts/offline/repository/VinculoRepository';
import MarcacaoRepository from '@/assets/ts/offline/repository/MarcacaoRepository';
import { format, parse, isToday } from 'date-fns';
import DynamicRepository from '@/assets/ts/offline/repository/DynamicRepository';
import { OfflineTablesName } from '@/assets/ts/offline/DynamicTables';
import { MarcacaoOffline } from '@/assets/ts/interfaces/Offline';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import axios from 'axios';
import ReconhecimentoFacialUtils from '@/assets/ts/utils/ReconhecimentoFacialUtils';

interface Action {
  name: string;
  label: string;
  cssClass: string;
  executeAction: Function;
  actionKey: string;
  icon: string;
}

interface VinculoPontoUnidade {
  NRVINCULOM: string;
  NRCPFPESSOA: string;
  NMVINCULOM: string;
  IDVINCULOM: string;
}

interface LocalizacaoPontoUnidade {
  latitude: number;
  longitude: number;
}

interface MarcacaoPontoUnidade {
  localizacao: LocalizacaoPontoUnidade;
  vinculo: VinculoPontoUnidade;
  picture: string;
}

interface CacheMarcacao {
  nrVinculo: string;
  horario: string;
}


@Component({
  name: 'RegistroPontoUnidade',
  components: {
    RegistroPontoUnidadeNumericKeyboard,
    ConfirmationDialog,
  },
})
class RegistroPontoUnidade extends Vue {
  // DATA
  private viewName = 'Registro de Ponto Unidade';

  private actions = [
    {
      name: 'entrada',
      label: 'Entrada',
      color: 'darkgreen',
      cssClass: '',
      executeAction: this.actionRegistrarPontoOnClick,
      actionKey: 'Enter',
      icon: 'login',
    },
    {
      name: 'saidaAlmoco',
      label: 'Almoço',
      color: 'olive',
      cssClass: '',
      executeAction: this.actionRegistrarPontoAlmocoOnClick,
      icon: 'restaurant',
    },
    {
      name: 'retorno',
      label: 'Retorno',
      color: 'darkgoldenrod',
      cssClass: '',
      executeAction: this.actionRegistrarPontoOnClick,
      icon: 'replay',
    },
    {
      name: 'saida',
      label: 'Saída',
      color: 'darkred',
      cssClass: '',
      executeAction: this.actionRegistrarPontoOnClick,
      icon: 'logout',
    },
  ];

  private keyboardInput = '';

  private showKeyboard = true;

  private vinculoInserido = {
    NMVINCULOM: '',
    NRVINCULOM: '',
    BATIDAS_DIA_ATUAL: '',
    IDVINCULOM: '', 
    HORARIOS_MARCACOES_DIA_ATUAL: '',
    icon: '',
    iconColor: '',
    timeToExpire: null,
  };

  private vinculos = [];
  private vinculosRecFacial = [];

  private TempoController = new TempoController();

  private showCamera = false;

  private cameraConfig = {
    cameraAreaId: 'camera__area',
    videoTagId: 'camera__area--view',
    canvasTagId: 'camera__area--sensor',
    imgTagId: 'camera_area--visualizer',
    canvasFaceTagId: 'camera__area--face',
  };

  private cameraParams = {
    IDs: {
      video: `#${this.cameraConfig.videoTagId}`,
      canvas: `#${this.cameraConfig.canvasTagId}`,
      img: `#${this.cameraConfig.imgTagId}`,
      canvasFace: `#${this.cameraConfig.canvasFaceTagId}`,
    },
  };

  private camera = new CameraController(
    this.cameraParams.IDs.video,
    this.cameraParams.IDs.canvas,
    this.cameraParams.IDs.img,
    this.cameraParams.IDs.canvasFace,
  );

  private confirmationDialog = {
    isVisible: false,
    acceptText: 'Sim',
    declineText: 'Não',
    message: 'Deseja realizar a marcação?',
  };

  private marcacaoAtual: MarcacaoPontoUnidade = {
    vinculo: { NRVINCULOM: '', NRCPFPESSOA: '', NMVINCULOM: '', IDVINCULOM: ''},
    picture: '',
    localizacao: { latitude: null, longitude: null },
  };

  private screenSetup = {
    defaultScreenVisualization: {
      systemVariables: {
        keyboardInput: '',
        showCamera: false,
        showKeyboard: true,
      },
      camera: 'off',
    },
    defaultCameraVisualization: {
      systemVariables: {
        showCamera: true,
      },
      camera: 'on',
    },
    defaultAfterMarcacaoScreenVisualization: {
      systemVariables: {
        keyboardInput: '',
        showCamera: false,
      },
      camera: 'off',
    },
  };

  private screenSetupConfig = {
    actions: {
      camera: {
        on: async () => await this.camera.initTransmitionCameraDevice(),
        off: () => CameraController.stopUsingCameraDevice(this.cameraParams.IDs.video),
      },
    },
  };

  private cameraId = '';
  private cameraIsOpen = false;
  private messageMultipleFacesPhoto = 'Detectamos 2 rostos na imagem. Por favor, garanta que apenas um rosto esteja visível na foto para uma análise precisa.';
  private messageMultipleFacesLive  = 'Foram detectadas mais de uma face. Certifique-se de que apenas uma pessoa esteja presente para continuar.';

  // Facial
  private photoFacialBase64 = null;
  private timeoutDelayFaceDetectionInScreen = null;
  private timeoutDelayFaceDetection = null;
  private IsPhotoInProgress = false;
  private isFacialRecognitionLoading = false;
  private isRecFacialClicked = false;
  private contadorFoto = 0;
  private reconhecimentoLiberado = false;
  private timerRecFacial = 1000;
  private faceDetectionListener: any = null;


  private behindKeyboardMessagesConfig = {
    timing: {
      [MessageType.Success]: 2000,
      [MessageType.Error]: 2000,
      [MessageType.Warning]: 4000,
      showVinculoName: 0,
    },
  };

  private pictureConfig = {
    timeToTakePhoto: 1500,
    timeToTakePhotoFacial: 1000,
  };

  private qrCodeConfig = {
    timeOutToHideCamera: 15000,
  };

  private timeoutCancelRequest = 10000;

  private baseMessages = {
    dataFailedToLoad: 'Não foi possível trazer as informações de @.',
    operationFailedToExecute: 'Não foi possível realizar a operação @.',
  };

  private messages = {
    registerSaved: 'Registro realizado com sucesso!',
    registerNotSaved: 'Registro não salvo.',
    sameMinuteRegister: 'Aguarde pelo menos três minutos para registrar uma nova marcação',
    inAtualization: 'Atualização automática em andamento. Aguarde...',
    registerNotSavedError: 'Marcação NÃO registrada. Tente novamente em alguns instantes.',
    vinculloNotFound: 'Vínculo não encontrado!',
    cameraAccessError: 'Não foi possível acessar a câmera. Verifique as permissões do navegador.',
    restrictAccessError: 'Não foi possível restringir o acesso à esta tela. Por favor, realize novamente os procedimentos.',
    unidadePeriodoNotAvailableError: 'Unidade/Período não disponível.',
    vinculosGestorFailedToLoad: this.baseMessages.dataFailedToLoad.replace('@', 'vínculos'),
    marcacaoFailedToSave: this.baseMessages.operationFailedToExecute.replace('@', 'realizar marcação'),
    vinculoDeFerias: 'Vínculo de férias. Marcação não registrada, favor procurar o RH.',
    aguardandoFaces: 'Aguardando detecção de face...',
    baixoScoreFace: 'Face detectada, porém a qualidade da imagem não está ideal. Ajuste a posição ou distância.',
    multipleFacesDetectedLive: this.messageMultipleFacesLive,
    multipleFacesDetectedPhoto: this.messageMultipleFacesPhoto,
    imagemScoreBaixo: 'O rosto detectado na imagem não possui uma qualidade ideal para o cadastro da biometria facial. Por favor, certifique-se de que o rosto esteja bem iluminado e claramente visível, para uma captura precisa.',
    nenhumRostoDectado: 'Não foi detectado nenhum rosto nesta imagem. Por favor, verifique se a foto está clara e bem iluminada, e tente novamente.',
    verificandoRecFacial: 'Verificando reconhecimento facial... Por favor, aguarde.',
    reconhecimentoFacialError: 'Ocorreu um erro ao tentar realizar o reconhecimento facial.',
    noFacesMatches: 'Não foi encontrada nenhuma correspondência para este rosto.',
    faceDetectionError: 'Ocorreu um erro ao iniciar a detecção facial.',
    restrictAccessRegist: 'Este perfil possui acesso apenas à tela de Registro de Ponto da Unidade.',
    reconhecimentoNotOrg: 'Reconhecimento Facial não disponível para esta organização.',
    reconhecimentoFacialNaoDisponivelOffline: 'O Reconhecimento Facial não é habilitado para uso offline do aplicativo.',
    qrcodeNotNumber: 'Valor do QR code inválido: deve ser um número.'
  };

  private routes = {
    getVinculosDoGestorAndPerfilRegPntMlt: 'getVinculosDoGestorAndPerfilRegPntMlt',
    registraMarcacao: 'registraMarcacaoHcmServices',
    registraMarcacaoAlmoco: 'registraMarcacaoAlmocoHcmServices',
  };

  private defaults = {
    nmestruturam: 'Unidade indisponível',
  };

  private setRegistroComAlmoco = false;

  private registroEmAndamento = false;

  private fullScreenActivated = false;

  private messageTypeIconRelation = {
    [MessageType.Error]: {
      icon: 'error',
      color: 'red',
    },
    [MessageType.Warning]: {
      icon: 'warning',
      color: 'yellow',
    },
    [MessageType.Success]: {
      icon: 'check',
      color: 'green'
    },
  };

  private registrosSalvosDesdeUltimaAtualizacao: CacheMarcacao[] = [];

  private isVinculoBehindKeyboard = false;

  private lastClockInQRCodeScanned = false;

  // STORE
  @Getter('user')
  private user: any;

  @Getter('estruturaGerencialAtual')
  private estruturaGerencialAtual: any;

  @Getter('periodosDemonstrativo')
  private periodosDemonstrativo: any;

  @Getter('popUps')
  private popUpConfirmPassword: any;

  @Getter('loadingVisibility')
  private loadingVisibility: boolean;

  @Getter('loadingIsForceHidden')
  private loadingIsForceHidden: boolean;

  @Mutation('changeCurrentView')
  private changeCurrentView: any;

  @Mutation('setIntervalRPUReloadId')
  private setIntervalRPUReloadId: any;

  private get unidadePeriodofiltersAreAvailable() {
    return this.estruturaGerencialAtual && this.periodosDemonstrativo[0].NRPERIODOAPURACAO;
  }

  private get nomeUnidade() {
    return this.estruturaGerencialAtual ? this.estruturaGerencialAtual.NMESTRUTURA : this.defaults.nmestruturam;
  }

  private get registroPontoRoute() {
    return this.setRegistroComAlmoco ? this.routes.registraMarcacaoAlmoco : this.routes.registraMarcacao;
  }

  private get isMobile() {
    return OfflineController.isMobile();
  }

  private get ultimasMarcacoesArmazenadas() {
    /* Marcacoes obtidas na busca dos vinculos */
    const marcacoesSalvasUltimaAtualizacao = this.vinculoInserido.BATIDAS_DIA_ATUAL ?
      this.vinculoInserido.BATIDAS_DIA_ATUAL.split(';') :
      [];

    /* Marcacoes amrazenadas em memoria apos a realizacao da requisicao */
    const marcacoesSincronizadasLocalmente = this.registrosSalvosDesdeUltimaAtualizacao
      .filter(m => m.nrVinculo == this.vinculoInserido.NRVINCULOM)
      .map(m => m.horario);
    
    const ultimasMarcacoes = [
      ...marcacoesSalvasUltimaAtualizacao,
      ...marcacoesSincronizadasLocalmente,
    ];

    return ultimasMarcacoes
      .sort()
      .reverse()
      .slice(0, 8); /* Limita a 8 marcacoes */
  }

  // LIFECYCLE
  private async created() {
    this.setIntervalReload();
    await this.onCreated();
    await this.initModulesReconhecimentoFacial();
  }

  private mounted() {
    this.onMounted();
  }

  private destroyed() {
    this.onDestroyed();
  }

  // WATCHERS
  /* Observa se o popUp de confirmacao de senha esta visivel ou nao */
  @Watch('$store.getters.popUpConfirmPassword', { immediate: true, deep: true })
  private popUpConfirmPasswordOnChange(popUp: any){
    if(!popUp || !popUp.isVisible){
      this.displayKeyboard();
      LoadingController.forceHideLoading();
      return;
    }

    LoadingController.cancelForceHideLoading();
  }

  private async makeRequests() {
    store.commit('setLoadingVisibility', true);
    try {
      if(!OfflineController.checkIsOffline()) {
        this.getTravaReconhecimento(false);
        this.getTimeRecFacial(false);
      }
      await this.getVinculosDoGestorAndPerfilRegPntMlt();
    } catch (error) {
    } finally {
      store.commit('setLoadingVisibility', false);
    }
  }

  private snapShotEffect() {
    return new Promise<void>((resolve, reject) => {
      const video: HTMLElement = document.querySelector('#camera__area');

      video.style.visibility = 'hidden';
      setTimeout(() => {
        video.style.visibility = 'visible';
        resolve();
      }, 100);
    });
  }

  private async getVinculosDoGestorAndPerfilRegPntMlt() {
    try {
      if (!this.unidadePeriodofiltersAreAvailable) {
        throw this.messages.unidadePeriodoNotAvailableError;
      }

      if(OfflineController.checkIsOffline()) {
        await this.setVinculosForOffline();
        return;
      }

      let timeoutCancel = null;

      if(this.isMobile) {
        // Caso existe vínculos em cache, um timeout de 10 segundos é configurado para cancelar 
        // a requisição caso ela ultrapasse esse tempo limite, permitindo que o fluxo continue no modo offline.

        const vinculos = await DynamicRepository.getDynamicTable(OfflineTablesName.GPE_VINCULOM);
        if(vinculos && vinculos.length) {
          timeoutCancel = this.timeoutCancelRequest;
        }
      }

      const data = await HttpRequest.get(this.routes.getVinculosDoGestorAndPerfilRegPntMlt, {
        requestType: 'FilterData',
        NRPERIODOAPURACAO: this.$store.state.periodoDemonstrativoAtual.NRPERIODOAPURACAO,
        NRESTRUTURAM: this.$store.getters.estruturaGerencialAtual.NRESTRUTURAM,
        NRORG: this.$store.getters.user.nrorg,
      }, false, null, true, null, timeoutCancel);

      const messages = data.data.messages;

      if (messages) {
        throw messages[0].message;
      }

      if (!data.data.dataset) {
        throw this.messages.vinculosGestorFailedToLoad;
      }

      const vinculos = data.data.dataset.data;

      this.vinculos = vinculos;

    } catch (error) {

      if(this.isMobile) {
        await this.setVinculosForOffline();
        return;
      }

      this.showMessageBehindKeyboard(
        (error as string),
        MessageType.Error,
        0
      );
    }
  }

  // ScreenSetup:
  // setUpName: {
  //  systemVariables: {
  //    // Variables to set
  //    var: 1
  //  },
  //  camera: {
  //    // Camera action - On or Off
  //  },
  // }
  private async setUpScreen(screenSetup = null) {
    try {
      if (!screenSetup) {
        screenSetup = this.screenSetup.defaultScreenVisualization;
      }

      // set camera funcionality
      await this.screenSetupConfig.actions.camera[screenSetup.camera]();

      // set screen control variables
      for (const param in screenSetup.systemVariables) {
        this[param] = screenSetup.systemVariables[param];
      }
    } catch (err) {
      throw err;
    }
  }

  private async enviaMarcacao(
    vinculo: VinculoPontoUnidade,
    picture: string,
    localizacao: LocalizacaoPontoUnidade
  ): Promise<boolean> {

    const timeoutCancel = this.isMobile ? this.timeoutCancelRequest : null;

    const data: any = await HttpRequest.post(this.registroPontoRoute, {
      requestType: 'Row',
      row: {
        NRVINCULOM: vinculo.NRVINCULOM,
        NRCPFPESSOA: vinculo.NRCPFPESSOA,
        CDOPERADOR: this.$store.state.user.cdoperador,
        DSLATITUDE: localizacao.latitude,
        DSLONGITUDE: localizacao.longitude,
        DSPATH: picture,
        NRORG: this.user.nrorg,
      },
    }, true, null, null, timeoutCancel);

    const messages = data.data.messages;

    if (messages) {
      throw messages[0].message;
    }

    if (!data.data.dataset) {
      throw this.messages.marcacaoFailedToSave;
    }

    const success = data.data.dataset.data.success;

    const marcacoesDia = data.data.dataset.data.marcacoesDia || [];
    const ultimaMarcacao = marcacoesDia.pop();
    this.registrosSalvosDesdeUltimaAtualizacao.push({ nrVinculo: vinculo.NRVINCULOM, horario: ultimaMarcacao });

    return success;
  }

  private async realizaProcessoMarcacao() {
    try {
      const success = await this.enviaMarcacao(
        this.marcacaoAtual.vinculo,
        this.marcacaoAtual.picture,
        this.marcacaoAtual.localizacao,
      );

      if (success) {
        await this.showMessageBehindKeyboard(
          this.messages.registerSaved,
          MessageType.Success
        );
      } else {

        if(this.isMobile) {
          await this.realizaProcessoMarcacaoOffline();
          return;
        }
        await this.showMessageBehindKeyboard(
          this.messages.registerNotSaved,
          MessageType.Warning,
        );
      }
    } catch (error) {
      // Em caso de erro na marcação normal, realiza a marcação offline
      // para evitar inconsistências no servidor e garantir que a marcação do usuário não seja travada
      if(this.isMobile) {
        await this.realizaProcessoMarcacaoOffline();
        if(axios.isCancel(error)) {
          OfflineController.setOfflineManually();
        }
        return;
      }

      const err = error as any;
      if(typeof err == 'string') {
        await this.showMessageBehindKeyboard(
          err,
          MessageType.Error,
        );
      } else {
        await this.showMessageBehindKeyboard(
          this.messages.registerNotSavedError,
          MessageType.Error,
        );
      }
    }

    this.setUpScreen(this.screenSetup.defaultAfterMarcacaoScreenVisualization);
  }

  private async questionaMarcacaoPonto(vinculo: VinculoPontoUnidade) {
    this.registroEmAndamento = true;

    try {

      if(OfflineController.isMobile()) {
        await CameraController.checkCameraAccessMobile();
      }

      const picture = await this.camera.takePicture();

      let localizacao = { latitude: 0, longitude: 0 };

      if(OfflineController.isMobile()) {
        try {
          // Cria um timeout de 3 segundos
          let timeoutId: NodeJS.Timeout;
          const timeout = new Promise<never>((_, reject) => {
            timeoutId = setTimeout(() => reject(new Error('Timeout')), 3000);
          });

          // Usa Promise.race para a geolocalização com timeout
          localizacao = await Promise.race([
            LocalizacaoController.getGeoLocation(),
            timeout
          ]);

          // Limpa o timeout se a geolocalização resolver primeiro
          clearTimeout(timeoutId);
        } catch (error) {
          localizacao = await this.getLocalizacaoOffline();
        }
      } else {
        localizacao = await LocalizacaoController.getGeoLocation();
      }

      this.marcacaoAtual = {
        picture,
        localizacao,
        vinculo,
      };

      if (this.$store.getters.user.idexigefotoregpntpg) {
        // Efeito de aparecer e desaparecer
        await this.snapShotEffect();
        // Aguarda o usuário visualizar a foto
        await this.sleep(this.pictureConfig.timeToTakePhoto);
      }

      await this.realizaProcessoMarcacao();

    } catch (err) {
      const error = err as any;

      this.showMessageBehindKeyboard(
        (error as string),
        MessageType.Error,
      );

      this.setUpScreen(this.screenSetup.defaultAfterMarcacaoScreenVisualization);
    } finally {
      this.registroEmAndamento = false;

      /* Mostra novamente a camera de scan de QR Code */
      this.returnToQrCodeScanIfSetted();
    }
  }

  private async showMessageBehindKeyboard(
    message: string,
    type: MessageType = null,
    timeOut: number = null,
  ): Promise<true> {
    /* Sinaliza que o que esta sendo exibido atras do teclado NAO e um vinculo */
    this.isVinculoBehindKeyboard = false;

    this.showKeyboard = false;

    /* Busca as informacoes de tempo de exibicao de acordo com o tipo */
    const timingTypeRelation = this.behindKeyboardMessagesConfig.timing[type];
    const time = timeOut || timeOut == 0 ?
      timeOut :
      timingTypeRelation;

    /* Busca as informacoes de icones de acordo com o tipo informado */
    const iconTypeRelation = this.messageTypeIconRelation[type] ||
      this.messageTypeIconRelation[MessageType.Warning];

    this.vinculoInserido.NRVINCULOM = message;
    this.vinculoInserido.NMVINCULOM = '';

    this.vinculoInserido.icon = iconTypeRelation ? iconTypeRelation.icon : null;
    this.vinculoInserido.iconColor = iconTypeRelation ? iconTypeRelation.color : null;
    this.vinculoInserido.timeToExpire = '';

    /* Apos um tempo esconde a mensagem, a menos que o tempo seja forcado como zero */
    if (time && time > 0) {
      await this.sleep(time);
      this.showKeyboard = true;
    }

    return true;
  }

  private showVinculoBehindKeyboard(
    time: number,
    action: Function,
  ) {
    /* Sinaliza que o que esta sendo exibido atras do teclado e um vinculo */
    this.isVinculoBehindKeyboard = true;

    this.showKeyboard = false;

    /* Exibe os segundo para a tiragem da foto */
    if (time > 0) {
      const interval = setInterval(() => {
        this.vinculoInserido.timeToExpire = time / 1000;
        time -= 1000;
  
        if (time < 0) {
          clearInterval(interval);
        }
  
      }, 1000);
    }

    setTimeout(() => {
      /* Aciona a proxima etapa */
      action(this.vinculoInserido);
    }, time + 2000);
  }

  private async registraPontoAction(keyboardInput: string, qrcodeKey?: string) {
    try {
      // Pesquisa pelo numero do vinculo e depois pelo CPF
      const vinculoKey = qrcodeKey ? qrcodeKey : keyboardInput;

      this.lastClockInQRCodeScanned = !Util.isEmptyOrBlank(qrcodeKey);

      const vinculo = this.vinculos.find((vinc: any) => vinc.NRVINCULOM == vinculoKey) ||
        this.vinculos.find((vinc: any) => vinc.NRCPFPESSOA == vinculoKey);

        this.showKeyboard = false;

      if (vinculo) {
        this.vinculoInserido = {
          IDVINCULOM: vinculo ? vinculo.NRVINCULOM : null,
          ...vinculo,
        };

        /* Avisa sobre marcações de um vínculo de férias */
        const isVinculoFerias: boolean = vinculo.ISVINCULOFERIAS === 'S';
        if(isVinculoFerias) {
          await this.showMessageBehindKeyboard(
            this.messages.vinculoDeFerias,
            MessageType.Warning,
          );

          this.returnToQrCodeScanIfSetted();
          return;
        }

        /* Evita marcacoes no mesmo minuto */
        if (this.isMarcacaoMesmoMinuto()) {
          await this.showMessageBehindKeyboard(
            this.messages.sameMinuteRegister,
            MessageType.Warning,
          );

          this.returnToQrCodeScanIfSetted();
          return;
        }

        if (this.$store.getters.user.idexigefotoregpntpg) {
          await this.setUpScreen(this.screenSetup.defaultCameraVisualization);
        }
        
        this.showVinculoBehindKeyboard(
          this.behindKeyboardMessagesConfig.timing.showVinculoName,
          this.questionaMarcacaoPonto,
        );
      } else {
        await this.showMessageBehindKeyboard(
          this.messages.vinculloNotFound,
          MessageType.Warning,
        );
        this.returnToQrCodeScanIfSetted();
      }
    } catch (error) {
      await this.showMessageBehindKeyboard(
        (error as string),
        MessageType.Error,
      );
    }
  }

  private sleep(ms) {
    return new Promise((resolve: any) => setTimeout(resolve, ms));
  }

  private deixarTela() {
    this.cancelDectationFlow();

    if (this.user.idpgrestringeregist && !OfflineController.checkIsOfflineAbsolute()) {
      this.clearBehindKeyboardMessage();
      this.hideKeyboard();
      PopupController.openConfirmPasswordPopUp();
      return;
    }

    IntervalController.cancelRPUIntervalReload();
    this.$router.push('/');
  }

  private setConfirmationDialogVisibility(visibility: boolean) {
    this.confirmationDialog.isVisible = visibility;
  }

  private clearBehindKeyboardMessage() {
    this.vinculoInserido = {
      NMVINCULOM: '',
      NRVINCULOM: '',
      BATIDAS_DIA_ATUAL: '',
      IDVINCULOM: '',
      HORARIOS_MARCACOES_DIA_ATUAL: '',
      icon: '',
      iconColor: '',
      timeToExpire: null,
    };
  }

  private hideKeyboard() {
    this.showKeyboard = false;    
  }

  private displayKeyboard() {
    this.showKeyboard = true;
  }

  private async actionRegistrarPontoOnClick(keyboardInput: string) {
    this.setRegistroComAlmoco = false;

    if(OfflineController.checkIsOffline()) {
      this.registraPontoActionOffline(keyboardInput);
      return;
    }

    this.registraPontoAction(keyboardInput);
  }

  private actionRegistrarPontoAlmocoOnClick(keyboardInput: string) {
    this.setRegistroComAlmoco = true;

    if(OfflineController.checkIsOffline()) {
      this.registraPontoActionOffline(keyboardInput);
      return;
    }

    this.registraPontoAction(keyboardInput);
  }

  private setTitleOverflowAnimation() {
    const titleContainer = document.querySelector('.registro__view__company');
    const titleText = document.querySelector('.registro__view__company__title');

    if (titleContainer.clientWidth < titleText.clientWidth) {
      titleText.classList.add('moving-overflow-text');
    }
  }

  private async onCreated() {
    this.changeCurrentView(this.viewName);
    this.clearRegistrosSalvosDesdeUltimaAtualizacao();
    await this.makeRequests();
    if (this.$store.getters.user.idexigefotoregpntpg) {
      try {        
        const cameraAccess = this.isMobile
          ? await CameraController.checkCameraAccessMobile()
          : await CameraController.checkCameraAccess();

        //this.camera.initTransmitionCameraDevice();
      } catch (err) {
        this.showMessageBehindKeyboard(
          this.messages.cameraAccessError,
          MessageType.Error,
          0
        );
      } 
    }

    try {
      if(OfflineController.checkIsOffline()) return;

      await OperadorController.restringeApenasMarcacaoPG();
    } catch (e) {

      // Em caso de erro, permite o uso no mobile sem interrupções (isso pode reduzir a segurança!!!)
      if(this.isMobile) return;

      this.showMessageBehindKeyboard(
        this.messages.restrictAccessError,
        MessageType.Error,
        0
      );
    }
  }

  private onMounted() {
    this.setTitleOverflowAnimation();
    Util.addFullScreenChangeListener(this.updateFullScreenFlag);
    
    /* Desabilita o loading convencional */
    LoadingController.forceHideLoading();
  }

  private onDestroyed() {
    /* Faz com que o loading convencional seja visivel novamente */
    LoadingController.cancelForceHideLoading();
  }

  /**
   * Executa a atualizacao automatica. Prioriza o registro da marcacao. Pode ser invocado apenas dentro do contexto da tela
   */
  private async onIntervalReload() {
    /* Log */
    console.log('Atualização iniciada em: ' + new Date);

    const registroPrestesOuSendoRealizado = !Util.isEmptyOrBlank(this.keyboardInput) ||
      this.registroEmAndamento;

    console.log(registroPrestesOuSendoRealizado ? 'Registro em andamento. Atualização adiada.' : 'Não há registro em andamento.');

    if (registroPrestesOuSendoRealizado) {
      return;
    }

    /* Reload */
    this.showMessageBehindKeyboard(this.messages.inAtualization, null, 0);
    await this.onCreated();
    this.onMounted();
    this.showKeyboard = true;

    /* Log */
    console.log('Atualização concluída.');
  }

  /**
   * Cria o intervalo periodico de atualizacao
   */
  private setIntervalReload() {
    const intervalId = setInterval(this.onIntervalReload, 1000 * 60 * Constants.EMS_MINUTES_RELOAD_INTERVAL);
    this.setIntervalRPUReloadId(intervalId);
  }

  /**
   * Faz com que a tela de registro de ponto fique em tela cheia
   */
  private toggleFullScreen() {
    const el = document.querySelector('.registro__screen');
    if (!el) {
      return;
    }

    if (this.updateFullScreenFlag()) {
      Util.requestFullScreenClose(el);
    } else {
      Util.requestFullScreen(el);
    }
  }

  /**
   * Atualiza flag interna que controla se a tela esta em tela cheia
   */
  private updateFullScreenFlag() {
    this.fullScreenActivated = !Util.isInFullScreen();
    return this.fullScreenActivated;
  }

  /**
   * Para o vinculo atual verifica se a marcacao a ser registrada sera no mesmo minuto
   * da anterior
   */
  private isMarcacaoMesmoMinuto() {
    const ultimoHorario = this.ultimasMarcacoesArmazenadas[0];
    if (!ultimoHorario) {
      return false;
    }

    const horaMinuto = Time.fromCurrentTime().toString();
    const verificacao = Time.fromCurrentTime().getSeconds() - Time.fromString(ultimoHorario).getSeconds() > 0 
                          && Time.fromCurrentTime().getSeconds() - Time.fromString(ultimoHorario).getSeconds() < 180;
    return verificacao;
  }

  /**
   * Redefine os registros sincronizados localmente
   */
  private clearRegistrosSalvosDesdeUltimaAtualizacao() {
    this.registrosSalvosDesdeUltimaAtualizacao = [];
  }


  // #region [ QR-CODE ]
  private initQrcode() {
    this.clearBehindKeyboardMessage();
    this.hideKeyboard();
    Html5Qrcode.getCameras().then(async devices => {
      if (devices && devices.length) {
        this.cameraId = devices[0].id;
        this.readQrCode();
        this.cameraIsOpen = true;
      } else {
        await this.showMessageBehindKeyboard(
          this.messages.cameraAccessError,
          MessageType.Error
        );
      }
    }).catch(async err => {
      await this.showMessageBehindKeyboard(
        this.messages.cameraAccessError,
        MessageType.Error
      );
    });
  }

  private readQrCode() {
    this.showMessageBehindKeyboard('Aguardando pela identificação de um QR Code...');
  
    const html5QrCode = new Html5Qrcode('reader-qrcode');
  
    html5QrCode.start(
      { facingMode: "user" },
      { fps: 10 },
      async (decodedText, decodedResult) => {
        try {
          // Parar a leitura do QR Code
          this.stopReadQrCode(html5QrCode);
  
          // Verificar se o texto decodificado é um número
          if (!this.isNumber(decodedText)) {
            await this.showMessageBehindKeyboard(this.messages.qrcodeNotNumber, MessageType.Error);
            return;
          }
  
          // Determina o modo de operação: offline ou online
          const isOffline = OfflineController.checkIsOffline();
          const registraPontoAction = isOffline ? this.registraPontoActionOffline : this.registraPontoAction;
          this.setRegistroComAlmoco = false;
  
          // Buscar vínculo correspondente
          const vinculo = this.vinculos.find((vinc) => vinc.NRVINCULOM == decodedText || vinc.NRCPFPESSOA == decodedText);
          if (vinculo) {
            this.vinculoInserido = {
              IDVINCULOM: vinculo ? vinculo.NRVINCULOM : null,
              ...vinculo
            };
  
            // Verificar quantidade de marcações para exibir diálogo de almoço, se necessário
            let quantidadeMarcacoes = 0;
            if(isOffline) {
              const marcacoes = await MarcacaoRepository.getMarcacoesByChaves(vinculo.NRVINCULOM, decodedText);
              quantidadeMarcacoes = marcacoes.length;
            } else {
              quantidadeMarcacoes = this.ultimasMarcacoesArmazenadas.length;
            }

            const isMarcacaoImpar = quantidadeMarcacoes % 2 !== 0;
  
            if (isMarcacaoImpar) {
              await DialogUtils.show(
                'Marcação',
                'É uma marcação de saída de almoço?',() => {
                  this.setRegistroComAlmoco = true;
                },
                async () => {
                  this.setRegistroComAlmoco = false;
                  await registraPontoAction(decodedText);
                },
                false
              );
            }
          }
  
          // Registrar ponto caso não seja encontrada uma vinculação
          await registraPontoAction(decodedText);
  
        } catch (err) {
          // Tratamento de erro durante a leitura e registro
          console.error('Erro ao processar QR Code:', err);
          this.showKeyboard = true;
        }
      },
      (errorMessage) => {
        console.error('Erro ao iniciar leitura do QR Code:', errorMessage);
      }
    ).catch((err) => {
      // Tratamento de erro ao iniciar o leitor
      this.stopReadQrCode(html5QrCode);
      this.showKeyboard = true;
      console.error('Erro ao iniciar leitura do QR Code:', err);
    });
  
    // Configurar timeout para parar leitura após um tempo
    setTimeout(() => {
      this.stopReadQrCode(html5QrCode);
      this.showKeyboard = true;
    }, this.qrCodeConfig.timeOutToHideCamera);
  }  

  private stopReadQrCode(html5QrCode: Html5Qrcode) {
    html5QrCode.stop().then((ignore) => {
      // QR Code scanning is stopped.
    }).catch((err) => {
      // Stop failed, handle it.
    });
  }

  private returnToQrCodeScanIfSetted() {
    if (this.lastClockInQRCodeScanned) {
      this.initQrcode();
    }
  }

  // #endregion

  // #region [ REC FACIAL ]
  private async initModulesReconhecimentoFacial () {  
    try {
      await CameraController.initLoadFaceModules();
    } catch (error) {
      const msg = error as string;
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR, 7000);
      await this.showMessageBehindKeyboard(msg, MessageType.Error, 7000);
    }
  }

  private async getTravaReconhecimento(loading = true) {
    const timeoutCancel = this.isMobile ? this.timeoutCancelRequest : null;

    try {
      const valorReferencia = await CommonRequests.getValorReferencia(
        'FAZ_RECONHECIMENTO',
        loading,
        timeoutCancel
      );
  
      this.reconhecimentoLiberado = valorReferencia == '1'; 
    } catch (error) {
      
    }
  }

  private async getTimeRecFacial(loading = true) {
    const timeoutCancel = this.isMobile ? this.timeoutCancelRequest : null;

    try {
      const valorReferencia = await CommonRequests.getValorReferencia(
        'TIMER_REC_FACIAL',
        loading,
        timeoutCancel
      );
    
      let time: number;
    
      if (!isNaN(parseFloat(valorReferencia))) {
        const numValorReferencia = parseFloat(valorReferencia);
    
        time = Math.min(Math.max(numValorReferencia * 1000, 1000), 3000);
      } else {
        time = 1000;
      }
  
      this.timerRecFacial = time;
    } catch (error) {
      
    }
  }
  

  private async initReconhecimentoFacial() {
    // Verificar se está offline
    if(OfflineController.checkIsOffline()){
      SnackbarUtils.showMessage(this.messages.reconhecimentoFacialNaoDisponivelOffline, SnackbarUtils.TYPE_INFO);
      return;
    }

    // Verificar se o reconhecimento facial está liberado
    if(!this.reconhecimentoLiberado) {
      await this.getTravaReconhecimento(false);
      
      // Verificar novamente após tentar obter a configuração
      if(!this.reconhecimentoLiberado) {
        SnackbarUtils.showMessage(this.messages.reconhecimentoNotOrg, SnackbarUtils.TYPE_INFO);
        return;
      }
    }
    
    try {
      if(this.isRecFacialClicked) return;

      this.isRecFacialClicked = true;
      await this.camera.initTransmitionCameraDevice();
      //await this.setUpScreen(this.screenSetup.defaultCameraVisualization);
      this.showCamera = true;
      this.isRecFacialClicked = false;

      this.clearBehindKeyboardMessage();
      this.hideKeyboard();
      this.camera.faceDetectLive();

      this.handleOnFaceDetection();

      // Adicionar timeout para cancelar o processo após um tempo
      setTimeout(() => {
        if (this.showCamera && !this.IsPhotoInProgress) {
          this.cancelDectationFlow();
          this.showMessageBehindKeyboard(
            "Tempo limite para marcação de ponto por reconhecimento facial excedido. Por favor, tente novamente.",
            MessageType.Warning
          );
        }
      }, 120000); // 1 minuto e 20 de timeout ou seja se caso demorar mais q isso pra bater o ponto a camera fecha e tal
    } catch (error) {
      await this.showMessageBehindKeyboard(
        this.messages.faceDetectionError,
        MessageType.Error,
      );
      this.camera.offDetect('detections', detections => {
        console.log('Eventos de detecção cancelados');
      });
    } finally {
      this.isRecFacialClicked = false;
    }
  }

  private async handleOnFaceDetection() {
    this.faceDetectionListener = async (detections: any) => {
      // Adicionar verificação de conexão periódica
      if (OfflineController.checkIsOffline()) {
        this.cancelDectationFlow();
        await this.showMessageBehindKeyboard(
          this.messages.reconhecimentoFacialNaoDisponivelOffline,
          MessageType.Warning
        );
        return;
      }
      
      if (!detections || !detections.length) {
        this.handleNoFacesDetected();
        return;
      }
      
      if (detections.length > 1) {
        this.handleMultipleFacesDetected(detections);
        return;
      }
      
      if (detections[0].score < 0.85) {
        this.handleLowFaceScoreDetected();
        return;
      }
      
      if (!this.IsPhotoInProgress) {
        await this.handleStartTakingPhotoToFacialRecognition();
      }
    };

    // Tempo de espera para iniciar a detecção baseado no valor de referência TIMER_REC_FACIAL
    this.showTimerDelayFaceDection();
    this.timeoutDelayFaceDetection = setTimeout(async () =>  {
      this.camera.onDetect('detections', this.faceDetectionListener);
    }, this.timerRecFacial);
  
  }

  private async handleStartTakingPhotoToFacialRecognition() {
    this.IsPhotoInProgress = true;

    if(this.isFacialRecognitionLoading) {
      this.IsPhotoInProgress = false;
      return;
    }

    const picture = await this.camera.takePicture(false);
    this.photoFacialBase64  = picture;

    await this.showMessageBehindKeyboard(
      this.messages.verificandoRecFacial
    );

    if(!this.isFacialRecognitionLoading) {
      this.clearIntervalTimeDelayInScreen();
      await this.reconhecimentoFacial();
    }

    this.IsPhotoInProgress = false;

  }

  private isValidNumber(value) {
    return (Number.isInteger(value) || /^\d+$/.test(value));
}

  private async reconhecimentoFacial() {
    this.isFacialRecognitionLoading = true;
    this.showCamera = false;
    this.setUpScreen(this.screenSetup.defaultAfterMarcacaoScreenVisualization);

    try {
      const vinculos = ReconhecimentoFacialUtils.tratarVinculosParaRecFacial(this.vinculos);

      if(!vinculos) {
        return;
      }
      this.cancelDectationFlow();
      const response = await ReconhecimentoFacialController.reconhecimentoFacial(this.photoFacialBase64, vinculos) as any;
      this.isFacialRecognitionLoading = false;

      if(this.isValidNumber(response)) {
        this.setRegistroComAlmoco = false;

        const vinculo = this.vinculos.find((vinc: any) => vinc.NRVINCULOM == response);

        if(vinculo) {
          this.vinculoInserido = {
            IDVINCULOM: vinculo ? vinculo.NRVINCULOM : null,
            ...vinculo,
          };

          const quantidadeMarcacoes = this.ultimasMarcacoesArmazenadas.length;

          if (quantidadeMarcacoes % 2 !== 0) {
            await DialogUtils.show('Marcação', 'É uma marcação de saída de almoço?', () => {
              this.setRegistroComAlmoco = true;
            }, async () => {
              this.setRegistroComAlmoco = false;
              await this.registraPontoAction(response);
              return;
            }, false);
          }
        }

        await this.registraPontoAction(response);
        return;
      }

      this.noFacesMatches();

    } catch (error) {
      this.showMessageBehindKeyboard(
        this.messages.reconhecimentoFacialError,
        MessageType.Error
      );
    }
    finally {
      this.isFacialRecognitionLoading = false;
    }
  }

  private async handleNoFacesDetected() {
    this.clearIntervalTimeDelayInScreen();
    await this.showMessageBehindKeyboard(
      this.messages.aguardandoFaces
    );
    this.IsPhotoInProgress = false;
  }

  private async handleMultipleFacesDetected(detections: []) {

    this.messageMultipleFacesLive = `Foram detectadas ${detections.length} faces. Certifique-se de que apenas uma pessoa esteja presente para continuar.`;
    this.clearIntervalTimeDelayInScreen();

    await this.showMessageBehindKeyboard(
      this.messageMultipleFacesLive
    );

    this.IsPhotoInProgress = false;
  }

  private async handleLowFaceScoreDetected() {
    this.clearIntervalTimeDelayInScreen();
    await this.showMessageBehindKeyboard(
      this.messages.baixoScoreFace
    );
    this.IsPhotoInProgress = false;
  }

  private cancelEventFaceDetection() {
    if (this.faceDetectionListener) {
      this.camera.offDetect('detections', this.faceDetectionListener);
      this.faceDetectionListener = null;
    }
  }

  private async noFacesMatches() {
    await this.showMessageBehindKeyboard(
      this.messages.noFacesMatches,
      MessageType.Error
    );

    this.displayKeyboard();
  }

  private cancelDectationFlow() {
    try {
      clearInterval(this.timeoutDelayFaceDetection);
      this.clearIntervalTimeDelayInScreen();
      this.showCamera = false;
      this.IsPhotoInProgress = false;
      this.isFacialRecognitionLoading = false;
      this.camera.cancelFaceDetection();
      this.cancelEventFaceDetection();
      this.setUpScreen(this.screenSetup.defaultAfterMarcacaoScreenVisualization);
      //CameraController.stopUsingCameraDevice(this.cameraParams.IDs.video);
    } catch (error) {
      console.log(`Erro ao cancelar o fluxo de Detecção Facial ${error}`);
    }
  }

  private clearIntervalTimeDelayInScreen() {
    clearInterval(this.timeoutDelayFaceDetectionInScreen);
  }

  private async verificaExisteRostoImagem() {
    const detections = await this.camera.detectFacesInImage(this.photoFacialBase64);

    if(!detections || !detections.length) {
      SnackbarUtils.showMessage(this.messages.nenhumRostoDectado, SnackbarUtils.TYPE_ERROR, 7000);
      return false;
    }

    if(detections.length > 1) {
      SnackbarUtils.showMessage(this.messages.multipleFacesDetectedPhoto, SnackbarUtils.TYPE_ERROR, 7000);
      return false;
    }

    if(detections[0].detection.score < 0.85) {
      SnackbarUtils.showMessage(this.messages.imagemScoreBaixo, SnackbarUtils.TYPE_ERROR, 10000);
      return false;
    }

    return true;
  }

  private async showTimerDelayFaceDection() {

    this.contadorFoto = Math.round(this.timerRecFacial / 1000);

    await this.showMessageBehindKeyboard(
      this.contadorFoto.toString()
    );

    clearInterval(this.timeoutDelayFaceDetectionInScreen);

    this.timeoutDelayFaceDetectionInScreen = setInterval(async () => {
      if (this.contadorFoto > 0) {

        this.contadorFoto--;
        await this.showMessageBehindKeyboard(
          this.contadorFoto.toString()
        );

      } else {
        clearInterval(this.timeoutDelayFaceDetectionInScreen);
        this.contadorFoto = 0;
      }
    }, 1000);
  }
  

  // #region [ OFFLINE ]
  async setVinculosForOffline() {
    const vinculos = await VinculoRepository.getVinculos();
    this.vinculos = vinculos;
  };

  private async registraPontoActionOffline(keyboardInput: string, qrcodeKey?: string) {
    try {
      const vinculoKey = qrcodeKey ? qrcodeKey : keyboardInput;

      this.lastClockInQRCodeScanned = !Util.isEmptyOrBlank(qrcodeKey);

      // Pesquisa pelo numero do vinculo e depois pelo CPF
      const vinculo = this.vinculos.find((vinc: any) => 
        vinc.NRVINCULOM == vinculoKey || vinc.NRCPFPESSOA == vinculoKey
      );

      const existMarcacao = await this.isMarcacaoMesmoMinutoOffline(vinculoKey, vinculo);

      /* Evita marcacoes no mesmo minuto */
      if(existMarcacao) {
        await this.showMessageBehindKeyboard(
          this.messages.sameMinuteRegister,
          MessageType.Warning,
        );

        this.keyboardInput = '';
        this.returnToQrCodeScanIfSetted();
        return;
      }

      this.showKeyboard = false;

      this.vinculoInserido = {
        IDVINCULOM: vinculo ? vinculo.NRVINCULOM : null,
        ...vinculo,
      };

      if (this.$store.getters.user.idexigefotoregpntpg) {
        await this.setUpScreen(this.screenSetup.defaultCameraVisualization);
      }

      this.showVinculoBehindKeyboard(
        this.behindKeyboardMessagesConfig.timing.showVinculoName,
        this.questionaMarcacaoPontoOffline,
      );

      //Verifica se a conexão voltou ao normal
      OfflineController.checkInternetConnection();
    } catch(error) {
        await this.showMessageBehindKeyboard(
        (error as string),
        MessageType.Error,
      );
    }
  }

  private async questionaMarcacaoPontoOffline(vinculo: VinculoPontoUnidade) {
    this.registroEmAndamento = true;

    try {

      if(OfflineController.isMobile()) {
        await CameraController.checkCameraAccessMobile();
      }

      const picture = await this.camera.takePicture();
      const localizacao = await this.getLocalizacaoOffline();

      this.marcacaoAtual = {
        picture,
        localizacao,
        vinculo,
      };

      await this.realizaProcessoMarcacaoOffline();

    } catch (error) {
      this.showMessageBehindKeyboard(
        (error as string),
        MessageType.Error,
      );
    } finally {
      this.registroEmAndamento = false;

      /* Mostra novamente a camera de scan de QR Code */
      this.returnToQrCodeScanIfSetted();
    }
  }

  private async realizaProcessoMarcacaoOffline() {
    try {
      const vinculo = this.marcacaoAtual.vinculo;

      const nrvinculom = vinculo.IDVINCULOM ? vinculo.IDVINCULOM : this.keyboardInput;

      if(!nrvinculom || !this.isNumber(nrvinculom)) {
        throw new Error('Identificador vazio.');
      };

      const nmvinculom = vinculo.NMVINCULOM ? vinculo.NMVINCULOM : 'Não Encontrado';
      const picture = this.marcacaoAtual.picture;
      const localizacao = this.marcacaoAtual.localizacao;
      const dataHora = format(new Date(), 'dd/MM/yyyy HH:mm:ss');
      const idAlmoco = this.setRegistroComAlmoco ? 'S' : 'N';

      const latitude = localizacao.latitude ? String(localizacao.latitude) : '0';
      const longitude = localizacao.longitude ? String(localizacao.longitude) : '0';

      const marcacao = {
        NRCHAVEVINCULO: nrvinculom,
        NMVINCULOM: nmvinculom,
        DTHRMARCACAOPONTO: dataHora,
        IDALMOCO: idAlmoco,
        DSLATITUDE: latitude,
        DSLONGITUDE: longitude,
        DSPATH: picture,
        DSERROMARCACAO: ''
      };

      const result = await MarcacaoRepository.setMarcacao(marcacao);

      if (result) {
        await this.showMessageBehindKeyboard(
          this.messages.registerSaved,
          MessageType.Success
        );
      } else {
        await this.showMessageBehindKeyboard(
          this.messages.registerNotSaved,
          MessageType.Warning,
        );
      }
    } catch (error) {
      SnackbarUtils.showMessage(error as string, SnackbarUtils.TYPE_ERROR, 7000);
      await this.showMessageBehindKeyboard(
        this.messages.registerNotSaved,
        MessageType.Warning,
      );
    }

    this.setUpScreen(this.screenSetup.defaultAfterMarcacaoScreenVisualization);
  };

  private async getLocalizacaoOffline() {
    const defaultGeo = { latitude: 0, longitude: 0 };
    try {
      const localizacao = await DynamicRepository.getDynamicTable(OfflineTablesName.USER_LOCATION);
      const resp = localizacao && localizacao.length > 0 ? localizacao[0] : defaultGeo;

      // Tenta converter LATITUDE e LONGITUDE para números
      const latitude = resp && resp.LATITUDE ? parseFloat(resp.LATITUDE) : NaN;
      const longitude = resp && resp.LONGITUDE ? parseFloat(resp.LONGITUDE) : NaN;

      // Verifica se os valores convertidos são números válidos
      if (!isNaN(latitude) && !isNaN(longitude)) {
        return { latitude, longitude };
      }

      // Retorna defaultGeo caso os valores não sejam números
      return defaultGeo
    } catch (error) {
      return defaultGeo;
    }
  }

  private async isMarcacaoMesmoMinutoOffline(
    keyboardInput: string,
    vinculo: VinculoPontoUnidade | undefined
  ): Promise<boolean> {
    try {
      const nrVinculom = vinculo ? vinculo.NRVINCULOM : keyboardInput;
      const nrCpfPessoa = vinculo ? vinculo.NRCPFPESSOA : null;
  
      const marcacoes = await MarcacaoRepository.getMarcacoesByChaves(nrVinculom, nrCpfPessoa);
  
      return this.checkMarcacoesIntervaloOffline(marcacoes);
    } catch (error) {
      return false;
    }
  }

  // Função para verificar se há alguma marcação dentro do intervalo de 3 minutos
  private checkMarcacoesIntervaloOffline(marcacoes: MarcacaoOffline[]): boolean {
    try {
      if (marcacoes.length === 0) return false;

      const ultimaMarcacao = marcacoes.reduce((maisRecente, marcacaoAtual) => {
        const dataMaisRecente = parse(maisRecente.DTHRMARCACAOPONTO, 'dd/MM/yyyy HH:mm:ss', new Date());
        const dataMarcacaoAtual = parse(marcacaoAtual.DTHRMARCACAOPONTO, 'dd/MM/yyyy HH:mm:ss', new Date());
    
        return dataMarcacaoAtual > dataMaisRecente ? marcacaoAtual : maisRecente;
      });

      const dtMarcacao = parse(ultimaMarcacao.DTHRMARCACAOPONTO, 'dd/MM/yyyy HH:mm:ss', new Date());
      const horaMinuto = format(dtMarcacao, 'HH:mm');

      const isHoje = isToday(dtMarcacao);

      if(!isHoje) return false;

      // Verificar se alguma marcação está dentro do intervalo
      return Time.fromCurrentTime().getSeconds() - Time.fromString(horaMinuto).getSeconds() < 180;

    } catch (error) {
      return false;
    }
  }

  private isNumber(value) {
    try {
      return !isNaN(Number(value)) && isFinite(value); 
    } catch (error) {
      return false;
    }
  }

}

export default RegistroPontoUnidade;
